import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-warning",
  "use": "icon-status-warning-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-status-warning\"><path d=\"M7.5 6.5h1V10h-1zm0 4.5h1v1h-1z\" /><path d=\"m8 3 5.4 10H2.6zm0-1c-.3 0-.7.2-.9.5l-5.4 10c-.3.7.2 1.5.9 1.5h10.8c.8 0 1.2-.8.9-1.5l-5.4-10C8.7 2.2 8.3 2 8 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol